// src/utils/pageHeaderMeta.js
// Gera subtítulo (breadcrumb) consistente a partir da rota.
// Não depende de backend e não altera regras de negócio.

function titleCase(str = "") {
  return str
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join(" ");
}

const SEGMENT_LABELS = {
  "": "Home",
  cadastros: "Cadastros",
  atendimento: "Atendimento",
  gerenciar: "Gerenciar",
  opcoes: "Opções",
  estoque: "Estoque",
  indicadores: "Indicadores",
  os: "Ordens de Serviço",
  "ordens-servico": "Ordens de Serviço",
  preventivas: "Preventivas",

  // 2º nível comum
  usuarios: "Usuários",
  empresas: "Empresas",
  setores: "Setores",
  maquinas: "Máquinas",
  defeitos: "Defeitos",
  procedimentos: "Procedimentos",
  clientes: "Clientes",
  fornecedores: "Fornecedores",
  pecas: "Peças",
};

function labelFor(seg = "") {
  const s = String(seg || "").toLowerCase();
  return SEGMENT_LABELS[s] || titleCase(s);
}

export function buildDefaultSubtitle(pathname = "/", titulo = "") {
  // Ex.: /cadastros/empresas/novo => Cadastros / Empresas / Novo
  const parts = String(pathname || "/")
    .split("?")[0]
    .split("#")[0]
    .split("/")
    .filter(Boolean);

  if (parts.length === 0) return "";

  const a = labelFor(parts[0]);
  const b = parts.length >= 2 ? labelFor(parts[1]) : "";

  // 3º nível: novo/editar/id etc.
  let c = "";
  if (parts.length >= 3) {
    const raw = parts[2];
    if (raw === "novo" || raw === "nova") c = "Novo";
    else if (raw === "editar" || raw === "edit") c = "Editar";
    else if (raw === "finalizadas") c = "Finalizadas";
    else if (raw === "abertas") c = "Abertas";
    else if (raw === "minhas") c = "Minhas";
    else if (raw.length > 16) c = ""; // provável id
    else c = labelFor(raw);
  }

  const crumbs = [a, b, c].filter(Boolean);

  // Não repete o título como breadcrumb final
  const t = String(titulo || "").trim().toLowerCase();
  const last = crumbs[crumbs.length - 1]?.trim().toLowerCase();
  if (t && last && t === last) {
    crumbs.pop();
  }

  return crumbs.join(" / ");
}

export function normalizeTitleFromPath(pathname = "/", fallback = "") {
  const parts = String(pathname || "/")
    .split("?")[0]
    .split("#")[0]
    .split("/")
    .filter(Boolean);

  if (parts.length === 0) return fallback || "Dashboard";
  if (parts.length === 1) return labelFor(parts[0]);
  return labelFor(parts[1]);
}
